import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getAuthApiClient } from "@shared/apis/sidekick/api-factories";
import { buildGetUsersQueryKey } from "./useGetUsers";
import { AdminResetPasswordResponse } from "@shared/apis/sidekick/generated";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: (data: AdminResetPasswordResponse, email: string) => void;
};

type Params = {
  email: string;
};

export const useAdminResetUserPassword = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getAuthApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ email }: Params) => {
      const response = await api.authControllerAdminResetPassword({
        adminResetPasswordRequest: {
          email,
        },
      });
      queryClient.invalidateQueries({ queryKey: buildGetUsersQueryKey() });
      onSuccess?.(response, email);
      return response;
    },
    onError: async (error) => {
      const apiError = await apiResponseErrorHandler(error);
      console.error("Failed to reset user password.", error);
      toast.error(apiError.errors[0]);
    },
  });

  return mutation;
};
